module.exports = __webpack_public_path__ + "img/check_on.69b97fe5.svg";